import { Route } from "react-router-dom";
import AffiliateScreen from "../../../container/Affiliate/AffiliateScreen";
import CreateAffiliateContainer from "../../../container/Affiliate/AffiliateScreen/CreateAffiliate";
import { APP_URLS } from "../../../utils/constant";

const AffiliateRoutes = (access = {}) => {
  const { create = false, view = false, edit = false } = access || {};
  const screenPermissions = { create, view, edit };

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.AFFILIATE.HOME}
          element={<AffiliateScreen screenPermissions={screenPermissions} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.AFFILIATE.CREATE}
          element={<CreateAffiliateContainer />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.AFFILIATE.EDIT}
          element={<CreateAffiliateContainer isEdit={true} />}
        />
      )}
    </>
  );
};

export default AffiliateRoutes;
